export interface Features {
  readonly events: {
    readonly passiveSupported: boolean
  }
}

function test(): Features {
  let passiveSupported = false
  try {
    const options = Object.defineProperty({}, 'passive', {
      get() {
        passiveSupported = true
      },
    })
    window.addEventListener('test', null as any, options)
  } catch {
    // Expected to fail on browsers without passive event listener support
  }

  const features = {
    events: {
      passiveSupported,
    },
  }

  return features
}

let features: Features

export default function (): Features {
  return features || (features = test())
}
